module.exports = __webpack_public_path__ + "img/VideoResume.23876c2b.svg";